import { axiosInstance } from "../../utils";

const actions = {
    FETCH_NOTIFICATIONS_REQUESTED: 'FETCH_NOTIFICATIONS_REQUESTED',
    FETCH_NOTIFICATIONS_SUCCEEDED: 'FETCH_NOTIFICATIONS_SUCCEEDED',
    FETCH_NOTIFICATIONS_FAILED: 'FETCH_NOTIFICATIONS_FAILED',

    FETCH_NOTIFICATIONS_HISTORY_REQUESTED: 'FETCH_NOTIFICATIONS_HISTORY_REQUESTED',
    FETCH_NOTIFICATIONS_HISTORY_SUCCEEDED: 'FETCH_NOTIFICATIONS_HISTORY_SUCCEEDED',
    FETCH_NOTIFICATIONS_HISTORY_FAILED: 'FETCH_NOTIFICATIONS_HISTORY_FAILED',

    PUSH_NOTIFICATIONS_REQUESTED: 'PUSH_NOTIFICATIONS_REQUESTED',
    PUSH_NOTIFICATIONS_SUCCEEDED: 'PUSH_NOTIFICATIONS_SUCCEEDED',
    PUSH_NOTIFICATIONS_FAILED: 'PUSH_NOTIFICATIONS_FAILED',

    SUBSCRIBE_NOTIFICATION_REQUESTED: 'SUBSCRIBE_NOTIFICATION_REQUESTED',
    SUBSCRIBE_NOTIFICATION_SUCCEEDED: 'SUBSCRIBE_NOTIFICATION_SUCCEEDED',
    SUBSCRIBE_NOTIFICATION_FAILED: 'SUBSCRIBE_NOTIFICATION_FAILED',

    subscriptionNotification: (params = undefined) => {
        return {
            type: actions.SUBSCRIBE_NOTIFICATION_REQUESTED,
            payload: params
        }
    },

    fetchNotifications: (params = undefined) => {
        return {
            type: actions.FETCH_NOTIFICATIONS_REQUESTED,
            payload: params
        }
    },
    fetchNotificationsHistory: (params = undefined) => {
        return {
            type: actions.FETCH_NOTIFICATIONS_HISTORY_REQUESTED,
            payload: params
        }
    },

    pushNotifications: (data = undefined) => {
        return {
            type: actions.PUSH_NOTIFICATIONS_REQUESTED,
            payload: data
        }
    },

    getNotifications: async (params = undefined) => {
        const url = `notifications`;

        let finalParams = {
            ...(params || {}),
        };

        // Scope to current supplier when role is 1 (similar to orders)
        try {
            const user = JSON.parse(localStorage.getItem("user") || "{}");
            if (user?.role === 1 && user?._id) {
                finalParams = {
                    ...finalParams,
                    supplier_id: finalParams?.supplier_id || user._id,
                };
            }
        } catch (e) {
            // ignore JSON errors
        }

        // Match mobile getAllNotificationsCall: use a fixed limit=100
        if (!finalParams.limit) {
            finalParams.limit = 100;
        }

        try {
            const notifications = await axiosInstance.get(url,{ params: finalParams });
            return notifications.data;
        } catch (error) {
            throw error;
        }
    },

    getNotificationsHistory: async (params = undefined) => {
        const url = `notifications/history`;

        let finalParams = {
            ...(params || {}),
        };

        // Scope to current supplier when role is 1 (similar to orders)
        try {
            const user = JSON.parse(localStorage.getItem("user") || "{}");
            if (user?.role === 1 && user?._id) {
                finalParams = {
                    ...finalParams,
                    supplier_id: finalParams?.supplier_id || user._id,
                };
            }
        } catch (e) {
            // ignore JSON errors
        }

        // Match mobile getAllNotificationsCall: use a fixed limit=100
        if (!finalParams.limit) {
            finalParams.limit = 100;
        }

        try {
            const notifications = await axiosInstance.get(url,{ params: finalParams });
            return notifications.data;
        } catch (error) {
            throw error;
        }
    },

    createNotifications: async (data = undefined) => {
        const url = `notifications`;

        const bodyData = {
            title: data?.title,
            body: data?.body,
            userids: data?.userids,
            admins: data?.admins,
            suppliers: data?.suppliers,
            customers: data?.customers,
            data: {
                target_screen: data?.target_screen,
                reference_id: data?.reference_id,
            },
        }

        try {
            const notifications = await axiosInstance.post(url, bodyData);
            return notifications.data;
        } catch (error) {
            throw error;
        }
    },

    subscribeNotification: async (data = undefined) => {
        const url = `notifications/token`;

        const bodyData = {
            registration_token: data?.fcm_token
        }

        try {
            const subscription = await axiosInstance.post(url, bodyData);
            return subscription.data;
        } catch (error) {
            throw error;
        }
    },

};
export default actions;
